import { CSSProperties, PropsWithChildren } from 'react';

import styles from './admin-card.module.css';

type AdminCardProps = PropsWithChildren<{
  padding?: CSSProperties['padding'];
  backgroundColor?: CSSProperties['backgroundColor'];
  backgroundHoverColor?: CSSProperties['backgroundColor'];
  borderRadius?: string;
  borderLeftWidth?: string;
  borderLeftColor?: string;
  className?: string;
}>;

const AdminCard = (props: AdminCardProps) => {
  const {
    children,
    padding = '16px',
    backgroundColor = 'var(--gray-900)',
    backgroundHoverColor = 'var(--gray-800)',
    borderLeftColor = 'var(--secondary-lightblue-500)',
    borderLeftWidth = '0px',
    borderRadius = 'var(--card-radius)',
    className,
  } = props;

  return (
    <div
      className={`${styles['admin-card']} ${className || ''}`}
      style={
        {
          '--adminCardPadding': padding,
          '--adminCardBackgroundColor': backgroundColor,
          '--adminCardHoverBackgroundColor': backgroundHoverColor,
          '--borderLeftColor': borderLeftColor,
          '--borderLeftWidth': borderLeftWidth,
          '--adminCardBorderRadius': borderRadius,
        } as CSSProperties
      }
    >
      {children}
    </div>
  );
};

export default AdminCard;
